module.exports = __webpack_public_path__ + "static/media/nu-kenzie.0b30a8e8.png";